import { render, staticRenderFns } from "./UserCenter.vue?vue&type=template&id=bfcda820&scoped=true"
import script from "./user_center.js?vue&type=script&lang=js&external"
export * from "./user_center.js?vue&type=script&lang=js&external"
import style0 from "./user_center.scss?vue&type=style&index=0&id=bfcda820&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfcda820",
  null
  
)

export default component.exports